export class ConsultationsReadsPostRequest {
  userId: string

  constructor(userId: string) {
    this.userId = userId
  }
}
